const contentTypeJson = "application/json";
const apiPlan = "/api/plan";

// Get a list of current users plans.
const myPlans = function () {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(apiPlan, requestOptions)
    .then(handleResponse)
    .then((plans) => {
      return plans;
    });
};

// Get a plan.
const getPlan = function (planId) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(apiPlan + "/" + planId, requestOptions)
    .then(handleResponse)
    .then((plan) => {
      return plan;
    });
};

const getCurrentPlanMembers = function (planId) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(apiPlan + "/" + planId + "/planMembers", requestOptions)
    .then(handleResponse)
    .then((plan) => {
      return plan;
    });
};

// Get a plan by group member
const getPlanByMember = function (planId) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(apiPlan + "/" + planId + "/member", requestOptions)
    .then(handleResponse)
    .then((plan) => {
      return plan;
    });
};

// Update a plan.
const updatePlan = function (planId, plan) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
    body: JSON.stringify(plan),
  };

  return fetch(apiPlan + "/" + planId, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
};

// Create a plan.
const create = function (name, description) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
    body: JSON.stringify({ name, description }),
  };

  return fetch(apiPlan, requestOptions)
    .then(handleResponse)
    .then((plan) => {
      return plan;
    });
};

/**
 * Create a group.
 *
 * Group object:
 *  "description": "string"
 *  "enabled": true
 *  "meterActive": true
 *  "name": "string"
 */
const createGroup = function (planId, group) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
    body: JSON.stringify(group),
  };

  return fetch(apiPlan + "/" + planId + "/group", requestOptions)
    .then(handleResponse)
    .then((groupResp) => {
      return groupResp;
    });
};

/**
 * Get groups for this plan
 */
const getGroups = function (planId) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(apiPlan + "/" + planId + "/group", requestOptions)
    .then(handleResponse)
    .then((groupsResp) => {
      return groupsResp;
    });
};

// Create a payment method.
const addPaymentMethod = function (planId, stripeTok) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(
    apiPlan + "/" + planId + "/paymentMethod/" + stripeTok,
    requestOptions
  )
    .then(handleResponse)
    .then((paymentMethod) => {
      return paymentMethod;
    });
};

// Delete payment method
const deletePaymentMethod = function (planId, paymentMethodId) {
  const requestOptions = {
    method: "DELETE",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(
    apiPlan + "/" + planId + "/paymentMethod/" + paymentMethodId,
    requestOptions
  ).then((resp) => {
    return resp;
  });
};

// Get payment methods
const paymentMethods = function (planId) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(apiPlan + "/" + planId + "/paymentMethod", requestOptions)
    .then(handleResponse)
    .then((methods) => {
      return methods;
    });
};

/**
 * One Time purchase
 *
 * purchse object should contain:
 * "creditCount": int,
 * "discountCode": "string",
 * "paymentMethodId": "string"
 */
const oneTimePurchase = function (planId, purchase) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
    body: JSON.stringify(purchase),
  };

  return fetch(apiPlan + "/" + planId + "/oneTimePurchase", requestOptions)
    .then(handleResponse)
    .then((receipt) => {
      return receipt;
    });
};

/**
 * Invite to plan
 */
const createInvitation = function (planId, emailAddress) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
    body: JSON.stringify({ emailAddress, owner: false }),
  };

  return fetch(apiPlan + "/" + planId + "/invitation", requestOptions).then(
    (status) => {
      return status;
    }
  );
};

/**
 * Accept invite to plan
 */
const acceptInvitation = function (token) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(apiPlan + "/invitation/" + token, requestOptions)
    .then(handleResponse)
    .then((invitation) => {
      return invitation;
    });
};

// Get the meter for a given planId
const meter = function (planId) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(apiPlan + "/" + planId + "/meter", requestOptions)
    .then(handleResponse)
    .then((meterResp) => {
      return meterResp;
    });
};

//Get the meter for a given planId by Group Admin
const meterByOwner = function (planId) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(apiPlan + "/" + planId + "/meter/owner", requestOptions)
    .then(handleResponse)
    .then((meterResp) => {
      return meterResp;
    });
};

// Get the meter events for a given planId
const meterEvents = function (planId) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(apiPlan + "/" + planId + "/meter/events", requestOptions)
    .then(handleResponse)
    .then((events) => {
      return events;
    });
};

/**
 * Transfer credits to and from groups
 * A positive number in the body represents credits moving from the plan
 * to the group and a negative number represents credits moving from
 * the group to the plan
 *
 * @param transaction.count: int
 * @param transaction.message: string
 * @param transaction.groupId: int
 */
const transferCredits = function (planId, transaction) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
    body: JSON.stringify(transaction),
  };

  return fetch(apiPlan + "/" + planId + "/credits", requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
};

const transferCreditsByOwner = function (planId, transaction) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
    body: JSON.stringify(transaction),
  };

  return fetch(apiPlan + "/" + planId + "/credits/owner", requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
};

// Delete a plan owner
const deleteOwner = function (planId, appUserId) {
  const requestOptions = {
    method: "DELETE",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(apiPlan + "/" + planId + "/owner/" + appUserId, requestOptions)
    .then(handleResponse)
    .then((response) => {
      return response;
    });
};

// Get the owners for a given planId
const owners = function (planId) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(apiPlan + "/" + planId + "/owner", requestOptions)
    .then(handleResponse)
    .then((ownersResp) => {
      return ownersResp;
    });
};

const whitelistAccess = function (planId) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": contentTypeJson },
    mode: "cors",
  };

  return fetch(apiPlan + "/" + planId + "/whitelistAccess", requestOptions)
    .then(handleResponse)
    .then((resp) => {
      return resp;
    });
};

const handleResponse = function (resp) {
  return resp.text().then((text) => {
    let data;
    try {
      data = text && JSON.parse(text);
    } catch (e) {
      data = e;
    }
    if (!resp.ok) {
      if (resp.status === 503) {
        localStorage.removeItem("user");
        location.replace("/maintenance");
      }

      if (resp.status === 403) {
        localStorage.removeItem("user");
        location.replace("/login");
      }

      if (resp.status === 401) {
        location.reload(true);
      }

      if (resp.status === 404) {
        location.replace("/error?err=404");
      }

      const err = (data && data.message) || resp.statusText;
      return Promise.reject(err);
    }

    return data;
  });
};

export const planService = {
  myPlans,
  getPlan,
  getCurrentPlanMembers,
  getPlanByMember,
  updatePlan,
  create,
  createGroup,
  getGroups,
  addPaymentMethod,
  deletePaymentMethod,
  paymentMethods,
  oneTimePurchase,
  createInvitation,
  acceptInvitation,
  meter,
  meterByOwner,
  meterEvents,
  transferCredits,
  transferCreditsByOwner,
  owners,
  deleteOwner,
  whitelistAccess,
};
